import { render, staticRenderFns } from "./cert-contents.vue?vue&type=template&id=54630f10&scoped=true&"
import script from "./cert-contents.vue?vue&type=script&lang=js&"
export * from "./cert-contents.vue?vue&type=script&lang=js&"
import style0 from "./cert-contents.vue?vue&type=style&index=0&id=54630f10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54630f10",
  null
  
)

export default component.exports